import {Button} from "antd";
import React from "react";
import PropTypes from "prop-types";

const BackButton = ({ history }) => (
  <Button icon="arrow-left" onClick={() => history.length === 1 ? window.close() : history.goBack()} />
);

BackButton.propTypes = {
  history: PropTypes.object.isRequired,
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/common/BackButton.js